import { Pressable, StyleSheet, Text } from "react-native";
import { useTranslation } from "react-i18next";

import { Icon } from "../Icon/Icon";
import { hiddenFromScreenReader } from "../primitives/hiddenFromScreenReader";
import type { UiTheme } from "../theme";

// AP-9b: the link under «Below the minimum effective volume so far: N». ONE
// link for the whole card, never inside a muscle row: the draft covers every
// gap at once, and a link inside «Lats» would promise a lats-only session.
// Tertiary on purpose (ink2, underlined, between two rules): the card reads
// the week, the link is a way out of it.
export function BuildTodayLink({
  theme,
  onPress,
}: {
  theme: UiTheme;
  onPress: () => void;
}) {
  const { t } = useTranslation();
  const styles = makeStyles(theme);
  const label = t("progress.gapProposal.buildToday", {
    defaultValue: "Build today's session from these gaps",
  });
  return (
    <Pressable
      accessibilityRole="link"
      accessibilityLabel={label}
      onPress={onPress}
      style={({ pressed }) => [styles.row, pressed && styles.pressed]}
    >
      <Icon name="target" size={theme.typography.sizes.md} color={theme.palette.ink2} />
      <Text style={styles.label}>{label}</Text>
      <Text style={styles.chevron} {...hiddenFromScreenReader()}>
        ›
      </Text>
    </Pressable>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: ty } = theme;
  return StyleSheet.create({
    row: {
      flexDirection: "row",
      alignItems: "center",
      gap: s.s3,
      minHeight: 44,
      paddingVertical: s.s2,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: p.border,
    },
    pressed: { opacity: 0.6 },
    label: {
      flex: 1,
      color: p.ink2,
      fontSize: ty.sizes.base,
      fontWeight: "600",
      textDecorationLine: "underline",
    },
    chevron: { color: p.ink3, fontSize: ty.sizes.lg },
  });
}
